var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHouse = function SvgHouse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 105.894 105.903",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_house_1233598_000000",
    transform: "translate(-10 -9.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_343",
    "data-name": "Caminho 343",
    d: "M10.667,54.594A1.327,1.327,0,0,0,12,54.589l7.766-4.54L19.757,103.4h-3.7a1.323,1.323,0,0,0-1.324,1.324l.005,9.85a1.323,1.323,0,0,0,1.324,1.324h93.769a1.323,1.323,0,0,0,1.324-1.324v-9.85a1.323,1.323,0,0,0-1.324-1.324h-3.7V50.054l7.766,4.54a1.333,1.333,0,0,0,.667.181,1.29,1.29,0,0,0,.657-.176,1.329,1.329,0,0,0,.667-1.153V42.526a1.323,1.323,0,0,0-.636-1.132l-11.272-6.815-.005-23.159a1.323,1.323,0,0,0-1.324-1.324H88.594A1.323,1.323,0,0,0,87.27,11.42V24.47L63.636,10.184a1.1,1.1,0,0,0-.429-.155,1.325,1.325,0,0,0-.988.155L10.636,41.394A1.336,1.336,0,0,0,10,42.526v10.92a1.315,1.315,0,0,0,.667,1.148Zm97.838,58.655H17.389v-7.2h91.122ZM56.329,103.4H36.473V60.2H56.329Zm47.161,0H58.976V58.874a1.323,1.323,0,0,0-1.324-1.324H35.15a1.323,1.323,0,0,0-1.324,1.324V103.4H22.4V48.5L62.926,24.811l40.559,23.7ZM89.917,12.743h11.417V32.975l-11.417-6.9ZM12.647,43.275,62.926,12.846l50.321,30.429v7.87L63.593,22.132a1.32,1.32,0,0,0-1.334,0L12.647,51.139Z",
    transform: "translate(0 0)",
    fill: "#aac208"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_344",
    "data-name": "Caminho 344",
    d: "M56.074,71.143H78.726a1.323,1.323,0,0,0,1.324-1.324V47.168a1.323,1.323,0,0,0-1.324-1.324H56.074a1.323,1.323,0,0,0-1.324,1.324V69.82A1.323,1.323,0,0,0,56.074,71.143ZM57.4,59.732h8.681V68.5H57.4ZM68.726,68.5V59.732h8.681V68.5ZM77.4,57.085H68.721V48.491H77.4ZM66.079,48.491v8.594H57.4V48.491Z",
    transform: "translate(14.484 11.604)",
    fill: "#aac208"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHouse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/house.c15b9baa.svg";
export { ForwardRef as ReactComponent };